type WorkplaceFilterValues = {
  locationIds?: string[]
  workAreaIds?: string[]
}

export const toUniqueIds = (values: unknown): string[] | undefined => {
  if (!Array.isArray(values)) return undefined

  const normalizedIds = values
    .filter(
      (value): value is string | number => typeof value === 'string' || typeof value === 'number'
    )
    .map((value) => String(value))

  return normalizedIds.length ? [...new Set(normalizedIds)] : undefined
}

export const mergeUniqueIds = (...idGroups: Array<string[] | undefined>): string[] | undefined => {
  const mergedIds = idGroups.flatMap((ids) => ids ?? [])

  return mergedIds.length ? [...new Set(mergedIds)] : undefined
}

export const extractWorkplaceFilterValues = (filters: unknown): WorkplaceFilterValues => {
  const locationIds = toUniqueIds(Reflect.get(Object(filters), 'workplace'))
  const workAreaIds = toUniqueIds(Reflect.get(Object(filters), 'workArea'))

  return {
    locationIds,
    workAreaIds,
  }
}
